import { render, staticRenderFns } from "./PageHome.vue?vue&type=template&id=33e0cf66&"
import script from "./PageHome.js?vue&type=script&lang=js&"
export * from "./PageHome.js?vue&type=script&lang=js&"
import style0 from "./PageHome.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports